// extracted by mini-css-extract-plugin
export default {"gift-card-design-selector":"eBwOtNrS7H8A32iPzYpg","giftCardDesignSelector":"eBwOtNrS7H8A32iPzYpg"};